import React, { useMemo } from 'react';
import { OktonChart as Chart } from '@okton/platform-ui/charts';
import { DadosEvolucao } from '../../../services/hooks/useDashboard';
import { DESCRICAO_AGRUPAMENTO, rotuloEixo } from '../formatacao';
import CargaGrafico from './CargaGrafico';
import { useCoresDashboard } from './cores';

interface Props {
  dados?: DadosEvolucao;
  isLoading: boolean;
  isError: boolean;
  error?: unknown;
  onRetry: () => void;
  atualizando?: boolean;
}

const TITULO = 'Evolução da Conciliação';
const ALTURA = '420px';

const EvolucaoConciliacaoChart: React.FC<Props> = ({
  dados,
  isLoading,
  isError,
  error,
  onRetry,
  atualizando,
}) => {
  const cores = useCoresDashboard();
  const agrupamento = dados?.agrupamento ?? 'dia';
  // Memorizada: um refetch que devolve os mesmos dados mantém a mesma
  // referência (structural sharing do react-query), e o recharts não tem o
  // que animar.
  // Um dia só: os lançamentos do dia pela hora deles. Sem nenhum com hora,
  // o ponto do dia.
  const horas = dados?.temhora ? dados.horas : null;
  const serie = useMemo(
    () =>
      horas
        ? horas.map(p => ({
            periodo: p.hora,
            Conciliados: p.conciliados,
            Pendentes: p.pendentes,
            Divergentes: p.divergentes,
          }))
        : (dados?.rows ?? []).map(p => ({
            periodo: rotuloEixo(p.periodo, agrupamento),
            Conciliados: p.conciliados,
            Pendentes: p.pendentes,
            Divergentes: p.divergentes,
          })),
    [horas, dados, agrupamento],
  );
  const recorte = horas
    ? 'por hora do dia'
    : DESCRICAO_AGRUPAMENTO[agrupamento].toLowerCase();

  return (
    <CargaGrafico
      atualizando={atualizando}
      titulo={TITULO}
      isLoading={isLoading}
      isError={isError}
      error={error}
      onRetry={onRetry}
      h={ALTURA}
    >
      <Chart
        h={ALTURA}
        title={`${TITULO} (${recorte})`}
        toolTipMsg={horas ? 'Lançamentos do extrato nesta hora' : undefined}
        data={serie}
        format="line"
        formatosPermitidos={['line', 'bar']}
        graphColor={[cores.conciliado, cores.pendente, cores.divergente]}
        dataKeys={['Conciliados', 'Pendentes', 'Divergentes']}
        nameKey="periodo"
      />
    </CargaGrafico>
  );
};

export default EvolucaoConciliacaoChart;
